import { render, staticRenderFns } from "./CommentBlock.vue?vue&type=template&id=828ee080&"
import script from "./CommentBlock.vue?vue&type=script&lang=js&"
export * from "./CommentBlock.vue?vue&type=script&lang=js&"
import style0 from "./CommentBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBanner,VTextField})
